import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Configuration } from './models/configuration.model';

@Injectable()
export class ConfigService {
  private config: Configuration;

  constructor(private http: Http) {}

  load(url: string) {
    return new Promise<void>((resolve) => {
      this.http.get(url).map(
        (res) => res.json()
      ).subscribe((config: Configuration) => {
        this.config = config;
        resolve();
      })
    })
  }

  getConfiguration(): Configuration {
    return this.config;
  }
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts